import { MenuHeaderService } from "@lib/strapi/services/components/menu/menuHeader.service";
import {
  StrapiMenuStructDTO,
  MenuStructDTO,
} from "@lib/strapi/dtos/content-types/menuStruct.dto";
import { StrapiPages } from "@lib/strapi/pages";
import { StrapiResponse } from "@lib/strapi/dtos/core/response.dto";
import { StrapiRoutes } from "@lib/strapi/routes";
import { fetchAPI } from "@lib/strapi/fetch-api";

export class MenuStructService {
  static async fromStrapi(
    dto: MenuStructDTO,
    locale: string,
    strapiData?: StrapiMenuStructDTO,
  ): Promise<MenuStructDTO> {
    if (!strapiData) {
      return null;
    }
    if (dto == null) {
      dto = new MenuStructDTO();
    }
    dto.name = strapiData.name;
    dto.slug = strapiData.slug;
    dto.menuItems = await Promise.all(
      (strapiData.menuItems ?? []).map(
        async (item) => await MenuHeaderService.fromStrapi(locale, item),
      ),
    );
    return dto;
  }

  static async fetchAll(
    authToken: string,
    locale: string,
  ): Promise<MenuStructDTO[]> {
    const token = (process.env.CMS_API_TOKEN || process.env.STRAPI_API_TOKEN);
    const urlParamsObject = { locale };
    const response: StrapiResponse<StrapiMenuStructDTO[]> = await fetchAPI(
      StrapiRoutes.menuStructs(),
      urlParamsObject,
      token,
    );
    const dto = new MenuStructDTO();
    return await Promise.all(
      (response.data ?? []).map(
        async (item) =>
          await MenuStructService.fromStrapi(new MenuStructDTO(), locale, item),
      ),
    );
  }

  static async fetchBySlug(
    authToken: string,
    locale: string,
    slug?: string,
  ): Promise<MenuStructDTO> {
    const token = (process.env.CMS_API_TOKEN || process.env.STRAPI_API_TOKEN);
    const urlParamsObject = { locale, filters: { slug: slug } };
    const response: StrapiResponse<StrapiMenuStructDTO[]> = await fetchAPI(
      StrapiRoutes.menuStructs(),
      urlParamsObject,
      token,
    );
    const dto = new MenuStructDTO();
    if ((response.data ?? []).length === 0) {
      return null;
    }
    return await MenuStructService.fromStrapi(
      dto,
      locale,
      (response.data ?? [])[0],
    );
  }
}
